import { isWeb } from "../../bridges/BridgeServices";
import { isTokenPresent } from "../../utils/cookieHelper";
import "./Chatbot.scss";
import { appendHeader } from "./ChatbotUtil";

export const getDisplayDate = () => {
  const date = new Date();
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const displayDate = `${
    days[date.getDay()]
  }, ${date.getDate()} ${
    monthNames[date.getMonth()]
  } ${date.getFullYear()}`;

  return displayDate;
};

const Chatbot = ({ shouldOpenChatbot = false }) => {
  // load chatbot sdk when there's a token in the cookie
  if (!isWeb()) {
    return null;
  }
  if (
    isTokenPresent() &&
    !document?.getElementById("mobile-chat-container")
  ) {
    require("./ChatbotSdk");
  }

  // open chatbot when clicked on customer support button
  if (
    shouldOpenChatbot &&
    document?.getElementById("mobile-chat-container")
  ) {
    document
      .getElementById("mobile-chat-container")
      .click();
  }
  appendHeader();
  return null;
};

export default Chatbot;
